import * as THREE from "three";
import { houseBlocksPositions } from "../includes/house-blocks-positions.js";

/**
 * Global
 */
const blockSize = 1;
const blockGeometry = new THREE.BoxGeometry(blockSize, blockSize, blockSize);
const addBlock = (geometry, material, posX, posY, posZ) => {
  const block = new THREE.Group();
  const item = new THREE.Mesh(geometry, material);
  block.add(item);
  block.position.x = posX * blockSize;
  block.position.y = posY * blockSize;
  block.position.z = posZ * blockSize;
  return block;
};

/**
 * Houses
 */
export const addHouse = (experience, posX, posY, posZ, rotY) => {
  const house = new THREE.Group();

  for (const element in houseBlocksPositions) {
    const part = houseBlocksPositions[element];
    const texture = experience.textureLoader.load(part.texture);
    texture.magFilter = THREE.NearestFilter;
    texture.colorSpace = THREE.SRGBColorSpace;
    const material = new THREE.MeshBasicMaterial({
      map: texture,
    });
    part.positions.forEach((pos) => {
      const block = addBlock(blockGeometry, material, ...pos);
      house.add(block);
      if (element === "grinch") {
        experience.grinches.push(block);
      }
    });
  }

  house.position.x = posX;
  house.position.y = posY;
  house.position.z = posZ;
  house.rotation.y = rotY || 0;
  experience.scene.add(house);
  return house;
};

export const initHouses = (experience) => {
  addHouse(experience, -25, 10, 76, -0.44);
  addHouse(experience, -8, 5, 91, -0.15);
  addHouse(experience, -5, 6, -23, -0.68);
  addHouse(experience, -45, 10, 83, 0.53);
  addHouse(experience, 34, 7, 73, 0.53);
  addHouse(experience, 35, 10, 22, 0.68);
  addHouse(experience, 20, 5, 40, -1.46);
  addHouse(experience, 11, 6, 9, -1.17);
  addHouse(experience, -54, 8, 17, 0.14);
  addHouse(experience, 11, 3, 120, 0.39);
  addHouse(experience, 32, 8, -67, 0.14);

  if (experience.isDebugMode) {
    experience.debugHouse = {
      posX: 0,
      posY: 4,
      posZ: 0,
      rotY: 0,
    };
    const debugHouse = experience.debugHouse;
    experience.houseTest = addHouse(experience);
    experience.gui
      .add(debugHouse, "posX")
      .min(-100)
      .max(100)
      .step(1)
      .name("house.posX");
    experience.gui
      .add(debugHouse, "posY")
      .min(0)
      .max(30)
      .step(1)
      .name("house.posY");
    experience.gui
      .add(debugHouse, "posZ")
      .min(-100)
      .max(120)
      .step(1)
      .name("house.posZ");
    experience.gui
      .add(debugHouse, "rotY")
      .min(-Math.PI)
      .max(Math.PI)
      .step(0.01)
      .name("house.rotY");
  }
};

export function initHouseTest(experience) {
  let houseTest;
  const debugHouse = experience.debugHouse;
  console.log(houseTest);

  return houseTest;
}
